import axios from "./index.service";

export default class CartService {
  static addItemToCart(payload) {
    console.log({ payload });
    return axios({
      method: "POST",
      url: `/api/services/v1/carts/`,
      data: payload,
    });
  }

  static fetchAll(value) {
    const request = { addAlumniFee: value };
    return axios({
      method: "GET",
      url: `/api/services/v1/carts/`,
      params: request,
    });
  }

  static removeItem(id) {
    return axios({
      method: "DELETE",
      url: `/api/services/v1/carts/${id}`,
    });
  }

  static removeAllCartItem() {
    return axios({
      method: "DELETE",
      url: `/api/services/v1/carts/`,
    });
  }

  static totalItems() {
    return axios({
      method: "GET",
      url: `/api/services/v1/carts/total-items`,
    });
  }
}
